import { render, staticRenderFns } from "./SliderJourneyPhotoHighlight.vue?vue&type=template&id=32b4b4ba&scoped=true"
import script from "./SliderJourneyPhotoHighlight.vue?vue&type=script&lang=js"
export * from "./SliderJourneyPhotoHighlight.vue?vue&type=script&lang=js"
import style0 from "./SliderJourneyPhotoHighlight.vue?vue&type=style&index=0&id=32b4b4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4b4ba",
  null
  
)

export default component.exports